export default {
    transferHeader: 'Overfør',
    transferSubmit: 'Overfør',
    transferContinue: 'Fortsett',
    transferTryAgain: 'Prøv igjen',
    transferCustomerMessage:
        'Tjenesten koster kr 100,- renter beregnes fra i dag. Beløpet vil være på mottakerens konto i løpet av to virkedager. Du kan overføre inntil disponibel kreditt (inkl. gebyrer) og minimum kr 1000,-.',
    transferInitFailedMessage: 'Vi kunne dessverre ikke starte overføringen. Vennligst prøv igjen om et par minutter.',
    transferErrorMonthlyLimitReached:
        'Denne overføringen overgår dessverre din månedlige grense på 100 000 kr. Prøv igjen ved neste månedsskifte eller senk beløpet.',
    transferErrorOperationNotAllowed: 'Du har ikke lov til å gjennomføre en overføring.',
    transferErrorOperationNotAllowedOtherCard: 'Du har ikke lov til å gjennomføre en overføring på noen andres kort.',
    transferFromLabel: 'Fra',
    transferFromPlaceholder: 'Betal fra kort',
    transferFromModalTitle: 'Betale fra',
    transferFromErrorDescription: 'Noe gikk galt ved henting av kortene dine',
    transferFromWarningTitle: 'For å kunne betale må du ha et kredittkort',
    transferFromWarningDescription: 'Vennligst kontakt banken',

    transferToAccount: 'Til konto',
    transferToAccountPlaceholder: 'Kontonummer',
    transferToLabel: 'Til',
    transferToModalTitle: 'Overfør til',
    transferToModalPlaceholder: 'Overfør til konto',
    transferToErrorTitle: 'Noe gikk galt ved henting av mottakerne dine!',

    transferNoteTitle: 'KID',
    transferNotePlaceholder: 'Legg til KID',

    transferSuccessHeader: 'Overføringen er fullført',
    transferSuccessText:
        'Merk at overføringen er fullført, men det kan likevel ta litt tid før pengene er på mottakerens konto.',

    paymentSuccessHeader: 'Betalingen er fullført',
    paymentSuccessText:
        'Merk at betalingen er fullført, men det kan likevel ta litt tid før pengene er på mottakerens konto.',

    transferDeclinedText:
        'Vi beklager, dette gikk ikke helt etter planen. Sjekk om betalingen ble fullført før du prøver på nytt',
    transferDeclinedLinkText: 'Sjekk transaksjoner',

    transferChargeInfo: '100 kr i gebyr kommer i tillegg',
    moneyTransferNotAvailableMessage: '"Overføre fra kort" er midlertidig utilgjengelig',
    moneyTransferErrorTitle: 'Overføring fra kort er ikke tilgjengelig akkurat nå',
    moneyTransferErrorDescription: 'Kontakt banken for mer informasjon.',
};
